<template>
  <dialog-wrapper
    :getter="getPickupDeliveryEditDialog"
    :setter="SET_PICKUP_DELIVERY_EDIT_DIALOG"
    apply-padding
    :closeOnBackdrop="false"
    persistent
    :rounded="true"
    @opened="handleDialogOpen"
  >
    <template #body>
      <div class="header-section">
        <v-btn
          icon
          class="close-btn"
          @click="handleClose"
        >
          <i class="v-icon material-icons">cancel</i>
        </v-btn>
      </div>
    <h2 class="dialog-title">{{ showStaleTimePrompt ? $vuetify.t('$vuetify.groupOrder.staleTimeTitle') : (displayIsDelivery ? $vuetify.t('$vuetify.orderDialog.deliveryTitle') : $vuetify.t('$vuetify.orderDialog.title')) }}</h2>

    <template v-if="showStaleTimePrompt && !showChooseAnotherTime">
      <p class="stale-time-body" v-html="staleTimeBodyHtml"></p>

      <div class="suggested-slot-list">
        <button
          v-for="slot in suggestedSlots"
          :key="slot.dayId + '|' + slot.timeId"
          type="button"
          class="suggested-slot-row"
          :class="{ selected: selectedSlot === slot }"
          @click="selectedSlot = slot"
        >
          <span class="suggested-slot-radio"></span>
          <span class="suggested-slot-label">{{ slot.label }}</span>
          <span v-if="slot === suggestedSlots[0]" class="suggested-slot-tag">{{ $vuetify.t('$vuetify.groupOrder.staleTimeNearestSlotLabel') }}</span>
        </button>
        <button
          v-if="asapAvailable"
          type="button"
          class="suggested-slot-row"
          :class="{ selected: selectedSlot === asapSlot }"
          @click="selectedSlot = asapSlot"
        >
          <span class="suggested-slot-radio"></span>
          <span class="suggested-slot-label">{{ isDelivery ? $vuetify.t('$vuetify.orderDialog.deliverAsap') : $vuetify.t('$vuetify.orderDialog.pickUpAsap') }}</span>
        </button>
      </div>

      <a class="choose-another-time-link" @click="showChooseAnotherTime = true">{{ $vuetify.t('$vuetify.groupOrder.staleTimeChooseAnother') }}</a>

      <v-btn
        class="done-button"
        @click="confirmSuggestedSlot"
        :loading="isSubmitting"
        :disabled="isSubmitting || !selectedSlot"
        elevation="2"
      >
        {{ $vuetify.t('$vuetify.orderDialog.confirmSlot', selectedSlot ? selectedSlot.label : '') }}
      </v-btn>
      <v-btn
        class="go-back-button"
        text
        outlined
        :disabled="isSubmitting"
        @click="handleClose"
      >
        {{ $vuetify.t('$vuetify.orderDialog.goBack') }}
      </v-btn>
    </template>

      <template v-else-if="!noDaysAvailable">
      <div v-if="!showStaleTimePrompt" class="toggle-container">
        <div class="toggle-switch">
          <button
            class="toggle-btn disabled"
            :class="{ active: pickupOption === 0 }"
            @click="setNow"
            :disabled="isScheduleTakeoutManually"
          >
            {{ isDelivery ? $vuetify.t('$vuetify.orderDialog.deliverAsap') : $vuetify.t('$vuetify.orderDialog.pickUpAsap') }}          </button>
          <button
            class="toggle-btn"
            :class="{ active: pickupOption === 1 }"
            @click="setSchedule"
          >
            {{ $vuetify.t('$vuetify.orderDialog.schedule') }}
          </button>
        </div>
      </div>

      <div v-if="pickupInstructions"
        id="pickupInstructions"
        class="pickup-instructions"
        v-html="pickupInstructions"
      ></div>

      <div v-show="pickupOption == 1" class="schedule-container">
        <div class="select-group">
          <v-select
            name="order_day"
            :error="scheduledDay === 'default'"
            v-validate="'required'"
            :data-vv-as="dayLabel"
            :error-messages="showDateTimeError ? [$vuetify.t('$vuetify.orderDialog.selectDateTime')] : errors.collect('order_day')"
            v-model="scheduledDay"
            :label="dayLabel"
            :items="getStoreAvailableOrderDays"
            item-value="id"
            item-text="label"
            @change="dayChanged(); showDateTimeError = false; timeErrorMessage = null"
            :disabled="!allowSchedulingOrders || _isNullOrOne(getStoreAvailableOrderDays) || isPickUpDisabled"
            dense
          />
          <v-select
            name="order_time"
            v-validate="'required'"
            :data-vv-as="timeLabel"
            :error-messages="showDateTimeError ? [$vuetify.t('$vuetify.orderDialog.selectDateTime')] : errors.collect('order_time')"
            v-model="scheduledTime"
            :label="timeLabel"
            :items="hoursByDay"
            @change="showDateTimeError = false; timeErrorMessage = null"
            item-value="id"
            item-text="label"
            :disabled="!allowSchedulingOrders || _isNullOrOne(hoursByDay) || isPickUpDisabled"
            dense
          />
        </div>
      </div>
      <div v-if="timeErrorMessage" class="time-error-message">
        <v-icon small color="error" style="margin-right:4px;vertical-align:middle">error</v-icon>
        {{ timeErrorMessage }}
      </div>
      <v-btn
        class="done-button"
        @click="closeDialog"
        :loading="isSubmitting"
        :disabled="isSubmitting || isDoneDisabled"
        elevation="2"
      >
        {{ $vuetify.t('$vuetify.orderDialog.done') }}
      </v-btn>
    </template>
    <template v-else>
      <div class="schedule-container" style="align-items: center">
        <p>{{ $vuetify.t('$vuetify.orderDialog.noAvailableDays') }}</p>
      </div>
    </template>
    </template>
  </dialog-wrapper>
</template>

<script>
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import get from 'lodash/get';
import { EventBus } from "@/services/event-bus"
import { isNullOrEmpty, matchTranslation, ensureDateObject, formatDate, formatTime, getDisplayLocale } from "@/services/util.service"
import { commitGroupOrderTypeSwitch } from "@/services/group-order-switch.service"
import DialogWrapper from '@/components/Wrappers/DialogWrapper'

export default {
  components: {
    DialogWrapper,
    VuetifyGoogleAutocomplete
  },
  data: () => ({
    deliveryAddress: '',
    hasAddressError: false,
    deliveryDialog: false,
    dineInOnlyQueryParam: false,
    newInput: false,
    pickupOption: Boolean(
      window.__STORE__ &&
      window.__STORE__.settings &&
      window.__STORE__.settings.orderSettings &&
      window.__STORE__.settings.orderSettings.scheduleTakeoutDatetimeManually
    ) ? 1 : 0,
    isFromOrderTypeSwitch: false,
    // handleDialogOpen() clears isFromOrderTypeSwitch as soon as the dialog opens (it only
    // uses it to decide the initial ASAP/Schedule tab) -- so by the time the user clicks
    // Done/Cancel, isFromOrderTypeSwitch is always already false. This separate flag
    // captures the same intent but is only ever cleared by closeDialog/handleClose
    // themselves, so it survives long enough to gate the order-type propagation.
    wasOrderTypeSwitch: false,
    isSubmitting: false,
    showDateTimeError: false,
    noDaysAvailable: false,
    draftDay: null,
    draftTime: null,
    timeErrorMessage: null,
    // True when this open was triggered by the stale-schedule prompt (DEV-10333) rather
    // than the user manually clicking to edit -- hides the ASAP/Schedule toggle since
    // the point of this open is specifically to pick a new time, not to switch ASAP/schedule.
    isStaleTimePrompt: false,
    // The now-invalid scheduledTime that triggered the stale prompt, captured from
    // getPickupDeliveryEditDialogMessage before handleDialogOpen clears that store value.
    staleScheduledTime: null,
    // Suggestion-list view (default) vs. the full day/time picker, once the user taps
    // "Choose another time".
    showChooseAnotherTime: false,
    // The currently-selected suggested slot object ({dayId, timeId, label}) or asapSlot.
    selectedSlot: null,
  }),
  watch: {
    // This component stays mounted (kept alive via v-show elsewhere) even while the
    // guest is actually on Delivery -- isOrderDaysReady flips true every time ANY
    // order-type switch finishes refetching the cart, not just Pickup's. Without the
    // isPickUp guard, switching to Delivery silently called setNow() -> setOrderType
    // ('PICKUP'), snapping the guest back to Pickup right after they picked Delivery.
    isOrderDaysReady(newVal) {
      if (!this.isPickUp) return
      const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null)
      const alreadyHasTime = this.getCheckoutInfo && this.getCheckoutInfo.scheduledTime
      if (newVal && !scheduleTakeoutDatetimeManually && !alreadyHasTime) {
        this.setNow();
      }
    }
  },
  created() {
    this.dineInOnlyQueryParam = this.$route.query.dineInOnly;
    this._onOrderTypeSwitch = (value, toOrderType) => {
      // DEV-10416: the event is shared with DeliveryDialog, and a switch TO delivery is that
      // dialog's business. Taking it here left wasOrderTypeSwitch set (this dialog never opens
      // for it, so nothing cleared it) -- the host's next delivery-time edit then showed
      // "Pick Up Detail", and its Done switched the group order to PICKUP.
      if (toOrderType && toOrderType !== 'PICKUP') return;
      this.isFromOrderTypeSwitch = value;
      this.wasOrderTypeSwitch = value;
    }
    this._onResetTime = () => {
      this.$nextTick(() => {
        const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null)
        if (!scheduleTakeoutDatetimeManually) {
          this.setDayAndTimeIfOnlyOne();
          this.setNow();
        } else {
          this.setDayAndTimeIfOnlyOne();
        }
        this.isFromOrderTypeSwitch = false;
      });
    }
    EventBus.$on('orderTypeSwitch', this._onOrderTypeSwitch);
    EventBus.$on('resetTime', this._onResetTime);
  },
  beforeDestroy() {
    // Scoped to this instance's own handler refs -- see OrderTypeSelector.vue's
    // beforeDestroy for why unscoped EventBus.$off(name) is unsafe.
    EventBus.$off('orderTypeSwitch', this._onOrderTypeSwitch);
    EventBus.$off('resetTime', this._onResetTime);
  },
  computed: {
    // True as soon as the dialog opens for a stale-time prompt, not just once
    // handleDialogOpen's @opened handler runs -- dialog-wrapper renders the body
    // synchronously on open (v-if="dialogModel"), one tick before @opened fires, so
    // relying on isStaleTimePrompt alone flashed the normal ASAP/Schedule toggle first.
    // getPickupDeliveryEditDialogMessage is already set by the caller (Cart.vue/
    // CheckoutPage.vue) before it opens the dialog, so it covers that first render;
    // isStaleTimePrompt takes over once handleDialogOpen clears the message.
    showStaleTimePrompt() {
      return this.isStaleTimePrompt || !!this.getPickupDeliveryEditDialogMessage
    },
    // Days from and including the one the stale scheduledTime fell on -- suggestions must
    // be nearest to what the user actually picked (e.g. Aug 1), not nearest to today, or
    // confirming a "5:30 PM" suggestion while rescheduling Aug 1 would silently commit
    // 5:30 PM *today* (Jul 31) instead. Matches initializeDateTime()'s same day.id-is-a-
    // Date-object comparison. Falls back to all days (today-first) if nothing matches
    // (e.g. the stale day itself is no longer offered at all).
    //
    // day.id is always a store-local wall-clock Date (see getStoreAvailableOrderDays).
    // For group orders staleScheduledTime is a real UTC instant, so it must be converted
    // to the store's own timezone before comparing calendar fields -- same technique
    // isTimeStale() already uses (util.service.js) -- or the store's local calendar day
    // can read as one day off in a browser whose own local timezone differs from the
    // store's by enough to cross a day boundary (getFullYear/Month/Date below read the
    // *browser's* local time, not the store's). Solo orders' staleScheduledTime already
    // is a store-local wall-clock value with no timezone info, so it's read as-is.
    daysFromStaleDate() {
      const days = (this.getStoreAvailableOrderDays || []).filter(day => day.id !== 'default')
      if (!this.staleScheduledTime) return days
      const isGroupOrder = this.$store.getters['groupOrder/isInGroupOrder']
      let staleYear, staleMonth, staleDay
      if (isGroupOrder) {
        const storeTz = (this.getStore && this.getStore.timeZone) || 'America/Toronto'
        const wallClock = new Date(this.staleScheduledTime).toLocaleString('en-US', { timeZone: storeTz, year: 'numeric', month: '2-digit', day: '2-digit' })
        const [month, day, year] = wallClock.split('/')
        staleYear = Number(year)
        staleMonth = Number(month) - 1
        staleDay = Number(day)
      } else {
        const staleDate = new Date(this.staleScheduledTime)
        staleYear = staleDate.getFullYear()
        staleMonth = staleDate.getMonth()
        staleDay = staleDate.getDate()
      }
      const startIndex = days.findIndex(day => {
        const availableDate = new Date(day.id)
        return availableDate.getFullYear() === staleYear &&
               availableDate.getMonth() === staleMonth &&
               availableDate.getDate() === staleDay
      })
      return startIndex === -1 ? days : days.slice(startIndex)
    },
    // Up to 3 nearest available day/time slots, starting from the stale date (see
    // daysFromStaleDate) -- skips the 'now' ASAP entry, which gets its own row via
    // asapSlot. Spills into the next day only once the stale date's own slots run out.
    //
    // Also skips staleScheduledTime itself -- the exact day/time that just got rejected
    // by the backend (ORD_ERR_SCHEDULED_TIME_TOO_CLOSE) to open this very prompt. The
    // backend's advance-booking cutoff is computed as "now + buffer" at slot-fetch time,
    // then re-checked independently (with zero tolerance) at submit time -- so the grid
    // can still contain that same razor's-edge time on refetch if little enough real time
    // has passed. Without this, the prompt could re-suggest (and auto-select, see
    // handleDialogOpen) the very time it just told the guest was invalid: submit -> reject
    // -> reopen -> reoffer same time -> submit -> loop forever.
    suggestedSlots() {
      const slots = []
      const staleTime = this.staleScheduledTime ? new Date(this.staleScheduledTime).getTime() : null
      for (const day of this.daysFromStaleDate) {
        for (const time of (day.times || [])) {
          if (time.id === 'now') continue
          if (staleTime !== null && new Date(time.id).getTime() === staleTime) continue
          slots.push({ dayId: day.id, timeId: time.id, label: time.label })
          if (slots.length === 3) return slots
        }
      }
      return slots
    },
    asapAvailable() {
      const firstDay = this.daysFromStaleDate[0]
      return !!(firstDay && (firstDay.times || []).some(time => time.id === 'now'))
    },
    asapSlot() {
      const firstDay = this.daysFromStaleDate[0]
      return firstDay ? { dayId: firstDay.id, timeId: 'now', label: this.isDelivery ? this.$vuetify.t('$vuetify.orderDialog.deliverAsap') : this.$vuetify.t('$vuetify.orderDialog.pickUpAsap') } : null
    },
    // "The store can't have your order ready by <b>Thu, Jul 16 at 2:00 PM</b>. Pick a new
    // time to continue[ -- your group and guests' items won't change]." Group vs. solo
    // copy differs (only a group order has other carts to reassure), so this picks the
    // right locale string and fills in the bolded date/time itself -- v-html'd like
    // pickupInstructions already is elsewhere in this file.
    //
    // Time formatting mirrors CheckoutPage.vue's _formatScheduledTime exactly: solo
    // scheduledTime is already a store-local wall-clock value with no timezone info, so
    // formatTime() reads its hours/minutes as-is (no timeZone option). Only group orders
    // apply an explicit storeTz conversion. Applying storeTz to a solo time double-shifts
    // it by the browser-vs-store offset (e.g. 5:15 PM rendering as 8:15 PM).
    staleTimeBodyHtml() {
      if (!this.staleScheduledTime) return ''
      const isGroupOrder = this.$store.getters['groupOrder/isInGroupOrder']
      const locale = getDisplayLocale(this.$vuetify.lang.current)
      let datePart, timePart
      if (isGroupOrder) {
        // Group orders' staleScheduledTime is a real UTC instant -- both the date and
        // time parts need the store's own timezone, same as daysFromStaleDate/
        // suggestedSlots below, or the displayed date can land on the wrong calendar
        // day for guests whose browser timezone crosses a day boundary from the store's.
        const storeTz = (this.getStore && this.getStore.timeZone) || 'America/Toronto'
        const staleDate = new Date(this.staleScheduledTime)
        datePart = staleDate.toLocaleDateString(locale, { month: 'short', day: '2-digit', timeZone: storeTz })
        timePart = staleDate.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit', timeZone: storeTz })
      } else {
        // Solo scheduledTime is already a store-local wall-clock value with no timezone
        // info, so formatDate/formatTime read its fields as-is (no timeZone option).
        // Applying storeTz here would double-shift it by the browser-vs-store offset.
        datePart = formatDate(this.staleScheduledTime, locale)
        timePart = formatTime(this.staleScheduledTime)
      }
      const key = isGroupOrder
        ? '$vuetify.orderDialog.staleTimeBodyGroup'
        : '$vuetify.orderDialog.staleTimeBodySolo'
      return this.$vuetify.t(key, `<b>${datePart} at ${timePart}</b>`)
    },
    isScheduleTakeoutManually() {
      return Boolean(get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null));
    },
    isOrderDaysReady() {
      return this.getStoreAvailableOrderDays && this.getStoreAvailableOrderDays.length > 0;
    },
    pickupInstructions() {
      return matchTranslation(get(this.getStore, 'settings.pickupSettings.instructions.translations', []))
    },
    isPickUpDisabled(){
      return this.getStore.settings.orderSettings.onlinePickupDisabledUntil && 
             new Date(this.getStore.settings.orderSettings.onlinePickupDisabledUntil) > new Date();
    },
    orderNotes: {
      get() {
        return get(this.getCheckoutInfo, 'orderNotes', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          orderNotes: value
        })
      }
    },
    deliveryNotes: {
      get() {
        return get(this.getCheckoutInfo, 'deliveryNotes', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          deliveryNotes: value
        })
      }
    },
    scheduledDay: {
      get() { return this.draftDay },
      set(value) { this.draftDay = value }
    },
    scheduledTime: {
      get() { return this.draftTime },
      set(value) { this.draftTime = value }
    },
    // On the Schedule tab, Done must not silently fall back to ASAP -- require both a day and
    // an explicit (non-'now') time to be picked. ASAP tab is unaffected. draftTime can still
    // be 'now' here because handleDialogOpen() seeds it from an ASAP getCheckoutInfo and
    // setSchedule() (switching tabs) doesn't clear it -- without the 'now' check, that leftover
    // truthy value reads as "a time was picked" and Done stays clickable with nothing selected.
    isDoneDisabled() {
      return this.pickupOption === 1 && (!this.draftDay || !this.draftTime || this.draftTime === 'now')
    },

    getDeliveryAddressFormatted() {
      return get(this.getDeliveryAddressResult, 'formatted_address', '')
    },

    hoursByDay() {
      if (this.getStoreAvailableOrderDays && this.scheduledDay) {
        const searchDay = ensureDateObject(this.scheduledDay).getDate()
        const matchedDay = this.getStoreAvailableOrderDays.find(day => (new Date(day.id)).getDate() == searchDay)
        if (matchedDay) {
          return matchedDay.times.filter(time => time.id !== 'now')
        } else {
          return []
        }
      }
    },

    allowSchedulingOrders() {
      return !this.isDelivery || this.getStoreDeliveryProvider !== 'TINY_MILE'
    },
    // The committed order type (isDelivery/isPickUp) is intentionally NOT flipped until
    // Done is clicked (see the comment above the commitGroupOrderTypeSwitch call below) --
    // but the dialog's own text must reflect what the user is confirming INTO, not what's
    // still committed, or a DELIVERY->PICKUP confirm shows "Delivery Detail" the whole time
    // it's open. This dialog only takes orderTypeSwitch for the DELIVERY->PICKUP direction
    // (the listener in created() ignores switches TO delivery -- DEV-10416), so
    // wasOrderTypeSwitch unambiguously means PICKUP.
    displayIsDelivery() {
      return this.wasOrderTypeSwitch ? false : this.isDelivery
    },
    dayLabel() {
      return this.displayIsDelivery ? this.$vuetify.t('$vuetify.order.deliveryDay') : this.$vuetify.t('$vuetify.order.pickUpDay')
    },
    timeLabel() {
      return this.displayIsDelivery ? this.$vuetify.t('$vuetify.order.deliveryTime') : this.$vuetify.t('$vuetify.order.pickUpTime')
    },

    ...mapGetters([
      'getDeliveryAddressResult',
      'isDelivery',
      'isPickUp',
      'isDineIn',
      'getStore',
      'getDeliveryAddress',
      'getStoreDeliveryProvider',
      'getCheckoutInfo',
      'getStoreAvailableOrderDays',
      'getOrderType',
      'getPickupDeliveryEditDialog',
      'getPickupDeliveryEditDialogMessage',
      'getPickupDeliveryEditDialogAsapBlocked'

    ])
  },
  methods: {
    resetTime() {
      EventBus.$emit('resetTime');
    },
    async handleDialogOpen() {
        // Always refetch on open (not just when the list happens to be empty) so a
        // stale slot list is never shown for selection -- same pattern Uber Eats uses.
        // wasOrderTypeSwitch means state.orderType is still the OLD committed type (group
        // orders defer the flip until Done) -- without the override this would fetch the
        // old type's slots (e.g. Delivery's) while the user is confirming a switch to
        // Pickup, showing empty/wrong availability for the type they're actually picking.
        const fetchOptions = { forceTimeSlots: true }
        if (this.wasOrderTypeSwitch) {
          fetchOptions.orderTypeOverride = 'PICKUP'
        }
        await this.fetchShoppingCart(fetchOptions).catch(function() {});
        // Seed draft from current committed state
        this.draftDay = get(this.getCheckoutInfo, 'scheduledDay', null)
        this.draftTime = get(this.getCheckoutInfo, 'scheduledTime', null)
        // Programmatic-open message is the raw stale scheduledTime, not a display string
        // (staleTimeBodyHtml formats it) -- it's a different thing from timeErrorMessage
        // (a submit-time rejection string shown in the full picker), so don't cross-wire
        // them. Consume it once, then clear so it doesn't linger on the next normal open.
        this.timeErrorMessage = null
        this.isStaleTimePrompt = !!this.getPickupDeliveryEditDialogMessage
        this.staleScheduledTime = this.getPickupDeliveryEditDialogMessage || null
        this.showChooseAnotherTime = false
        this.selectedSlot = null
        this.SET_PICKUP_DELIVERY_EDIT_DIALOG_MESSAGE(null)

        // DEV-10499: submit-time re-validation rejected ASAP because the store stopped
        // accepting orders while the customer was checking out (cutoff/closure hit mid-flow).
        // Separate flag/branch from the stale-time-prompt handling above on purpose -- that
        // one replaces a specific now-invalid scheduled time; this one has no prior time to
        // reference, just needs the customer forced onto the Schedule tab with an explanation
        // and a sensible default so they can pick a real slot to continue.
        const wasAsapBlocked = this.getPickupDeliveryEditDialogAsapBlocked
        this.SET_PICKUP_DELIVERY_EDIT_DIALOG_ASAP_BLOCKED(false)
        if (wasAsapBlocked) {
          this.timeErrorMessage = this.$vuetify.t('$vuetify.cart.storeStoppedAcceptingOrders')
          this.$nextTick(() => {
            this.pickupOption = 1;
            this.seedEarliestAvailableDayTime();
          });
          return;
        }

        // The stale day/time is known-invalid (that's why we're here) -- don't try to
        // match it against getStoreAvailableOrderDays like a normal re-open would, just
        // seed the earliest actually-available day/time so the dropdowns never render
        // empty while the user picks a replacement (either via the suggestion list's
        // default selection or, if they tap "Choose another time", the full picker).
        if (this.isStaleTimePrompt) {
          this.$nextTick(() => {
            this.pickupOption = 1;
            this.seedEarliestAvailableDayTime();
            this.selectedSlot = this.suggestedSlots[0] || null;
          });
          return;
        }

        if (this.isFromOrderTypeSwitch || !this.getCheckoutInfo || !this.getCheckoutInfo.scheduledDay || !this.getCheckoutInfo.scheduledTime) {
          this.$nextTick(() => {
            const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null)
            if (scheduleTakeoutDatetimeManually) {
              this.setDayAndTimeIfOnlyOne();
              this.pickupOption = 1;
            } else {
              this.setDayAndTimeIfOnlyOne();
              this.setNow(true);
              this.pickupOption = 0;
            }
            this.isFromOrderTypeSwitch = false;
          });
          return;
        } else {
          this.$nextTick(() => {
            const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null)
            if (scheduleTakeoutDatetimeManually) {
              this.pickupOption = 1;
            } else {
              this.pickupOption = this.getCheckoutInfo.scheduledTime === 'now' ? 0 : 1;
            }
            this.initializeDateTime();
          });
        }
    },
    setNow(justOpened = false) {
      const daysAvailable = this.getStoreAvailableOrderDays
      // const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null)
      const filteredDays = daysAvailable.filter(day => day.id !== 'default')
      if (filteredDays && filteredDays.length) {
        const firstDay = filteredDays[0];
        const hasAsapOption = firstDay.times && firstDay.times.some(time => time.id === 'now');
        if (hasAsapOption) {
          this.scheduledDay = firstDay.id;
          this.scheduledTime = 'now';
          this.pickupOption = 0;
          return;
        } else {
          if (!justOpened && !this.$store.getters['groupOrder/isInGroupOrder']) {
            this.showSnack({
              text: this.$vuetify.t('$vuetify.orderDialog.notAvailable'),
              color: 'info'
            })
          }
        }
        // DEV-10499: no ASAP option -- this used to stage a real future time while
        // leaving pickupOption at 0 (ASAP tab lit, dropdowns hidden via v-show). Done
        // was clickable (isDoneDisabled only guards pickupOption === 1), so tapping it
        // silently submitted that future time while the customer believed ASAP was
        // still selected -- exactly the "silently auto-switched to a future time"
        // failure this ticket exists to remove. Switch to the Schedule tab instead so
        // the customer explicitly sees and confirms a real day/time before Done can work.
        this.pickupOption = 1;
        this.scheduledDay = get(filteredDays, '[0].id')
        this.scheduledTime = get(filteredDays, '[0].times[0].id')
        if (!this.$store.getters['groupOrder/isInGroupOrder']) {
          this.showSnack({
            text: this.$vuetify.t('$vuetify.orderDialog.earliestDate'),
            color: 'success'
          })
        }

        if (!this.isPickUp) {
          this.setOrderType('PICKUP');
        }
      } else {
        this.pickupOption = 1;
        if (!this.getPickupDeliveryEditDialog) {
          this.SET_PICKUP_DELIVERY_EDIT_DIALOG(true)
        } else {
          if (!this.$store.getters['groupOrder/isInGroupOrder']) {
            this.showSnack({
              text: this.$vuetify.t('$vuetify.orderDialog.notAvailable'),
              color: 'info'
            })
          }
        }
      }
    },
    setSchedule() {
      this.pickupOption = 1;
    },
    initializeDateTime() {
      try {
        if (!this.draftDay || !this.draftTime) return;

        const scheduledDay = new Date(this.draftDay);
        const matchedDay = this.getStoreAvailableOrderDays.find(day => {
          const availableDate = new Date(day.id);
          return availableDate.getFullYear() === scheduledDay.getFullYear() &&
                availableDate.getMonth() === scheduledDay.getMonth() &&
                availableDate.getDate() === scheduledDay.getDate();
        });

        if (matchedDay) {
          if (matchedDay.id !== this.draftDay) {
            this.draftDay = matchedDay.id
          }

          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.hoursByDay && this.hoursByDay.length) {
                let matchedTime = this.hoursByDay.find(time => time.id === this.draftTime);

                if (!matchedTime) {
                  const scheduledTime = new Date(this.draftTime);
                  matchedTime = this.hoursByDay.find(time => {
                    const availableTime = new Date(time.id);
                    return availableTime.getHours() === scheduledTime.getHours() &&
                          availableTime.getMinutes() === scheduledTime.getMinutes();
                  });
                }

                if (matchedTime && matchedTime.id !== this.draftTime) {
                  this.draftTime = matchedTime.id
                }
              }
            });
          });
        } else {
          // The previously-committed day is no longer in getStoreAvailableOrderDays (e.g.
          // today's slots ran out since the order was scheduled) -- leaving draftDay/draftTime
          // pointed at that stale day renders a selected day with an empty time list. Fall
          // back to the nearest actually-available day/time instead, same as a fresh open.
          this.setDayAndTimeIfOnlyOne();
        }
      } catch (err) {
        console.error('Error initializing date/time:', err);
      }
    },
    // "Confirm {time}" on the stale-prompt suggestion list -- writes the picked slot into
    // the same draftDay/draftTime that the full picker's Done button commits from, so this
    // reuses closeDialog()'s existing group-vs-solo commit logic instead of duplicating it.
    confirmSuggestedSlot() {
      if (!this.selectedSlot) return
      this.draftDay = this.selectedSlot.dayId
      this.draftTime = this.selectedSlot.timeId
      return this.closeDialog()
    },
    async closeDialog() {
      if (this.isSubmitting) return
      // On the Schedule tab specifically, an empty OR leftover-'now' draftTime must NOT be
      // treated as an implicit ASAP choice (that's the bug this guards against) --
      // isDoneDisabled already keeps the button unclickable in that state, this is the
      // defense-in-depth check for this handler. Scoped to !showStaleTimePrompt: the
      // stale-prompt suggestion list also runs with pickupOption forced to 1 (see
      // handleDialogOpen) but confirmSuggestedSlot() legitimately sets draftTime to 'now'
      // when the user picks its own ASAP row (asapSlot) -- that's a real, explicit choice,
      // not a leftover from switching tabs, so it must not be blocked here.
      const scheduleTabMissingSelection = this.pickupOption === 1 && !this.showStaleTimePrompt && (!this.draftDay || !this.draftTime || this.draftTime === 'now')
      const isAsap = !scheduleTabMissingSelection && (this.draftTime === 'now' || !this.draftTime)
      if (isAsap || (this.draftDay && this.draftTime)) {
        const prevDay = get(this.getCheckoutInfo, 'scheduledDay', null)
        const prevTime = get(this.getCheckoutInfo, 'scheduledTime', null)
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          scheduledDay: this.draftDay,
          scheduledTime: this.draftTime,
        })

        // For group orders, commit order type + schedule to the backend in one call.
        // This dialog serves two different callers: OrderTypeSelector.selectOption uses
        // it as the confirm step when switching DELIVERY -> PICKUP (wasOrderTypeSwitch is
        // true there), while PickupDetailsCard's edit icon opens it purely to reschedule
        // the CURRENT order type (wasOrderTypeSwitch stays false) -- only the former should
        // ever send PICKUP; the latter must keep whatever order type the order already has,
        // or every reschedule of a delivery order silently flips it to pickup.
        // The local order type is intentionally NOT flipped until this call succeeds -- if
        // the user cancels/exits beforehand, nothing should have changed, locally or on the backend.
        if (this.$store.getters['groupOrder/isInGroupOrder']) {
          this.isSubmitting = true
          const targetOrderType = this.wasOrderTypeSwitch ? 'PICKUP' : this.getOrderType
          try {
            await commitGroupOrderTypeSwitch(this.$store, {
              orderType: targetOrderType,
              dayId: isAsap ? null : this.draftDay,
              timeId: isAsap ? null : this.draftTime,
            })
            if (this.wasOrderTypeSwitch) {
              this.setOrderType('PICKUP')
            }
            this.wasOrderTypeSwitch = false
            this.isStaleTimePrompt = false
          } catch (e) {
            this.SET_CHECKOUT_INFO({ ...this.getCheckoutInfo, scheduledDay: prevDay, scheduledTime: prevTime })
            // isGroupVersionConflict: updateGroup already retried once against a fresh
            // version -- a conflict surviving that retry is unlikely to be the same
            // stale-read race, so this shows a distinct (but not overly specific) message.
            const key = e && e.isGroupVersionConflict ? '$vuetify.groupOrder.errorUpdateScheduleConflict' : '$vuetify.groupOrder.errorUpdateSchedule'
            this.$store.dispatch('showSnack', { text: this.$vuetify.t(key), color: 'error' }, { root: true })
          } finally {
            this.isSubmitting = false
          }
          // DEV-10416: the dialog closes either way -- a failed save abandons the switch too, so
          // it must not stay flagged into the next (delivery) time edit.
          this.wasOrderTypeSwitch = false
          this.SET_PICKUP_DELIVERY_EDIT_DIALOG(false)
          return
        }

        this.fetchShoppingCart().then(() => {
          this.isStaleTimePrompt = false
          this.wasOrderTypeSwitch = false // DEV-10416: closing ends the switch
          this.SET_PICKUP_DELIVERY_EDIT_DIALOG(false)
        }).catch((err) => {
          const errorCode = err && err.response && err.response.data && err.response.data.errorCode
          if (errorCode === 'ORD_ERR_SCHEDULED_TIME_INVALID' || errorCode === 'ORD_ERR_SCHEDULED_TIME_NOT_ALLOWED') {
            // Revert to previous time and keep dialog open so user can pick a valid time
            this.SET_CHECKOUT_INFO({
              ...this.getCheckoutInfo,
              scheduledDay: prevDay,
              scheduledTime: prevTime,
            })
            this.draftDay = prevDay
            this.draftTime = prevTime
            this.timeErrorMessage = err.response.data.errorMsg || 'This time is not available. Please select a different time.'
            this.SET_PICKUP_DELIVERY_EDIT_DIALOG(true)
          } else {
            // Non-time error — close dialog anyway, snack was already shown by cart store
            this.wasOrderTypeSwitch = false // DEV-10416: closing ends the switch
            this.SET_PICKUP_DELIVERY_EDIT_DIALOG(false)
          }
        })
      } else {
        this.showDateTimeError = true;
        this.showSnack({
          text: this.$vuetify.t('$vuetify.orderDialog.selectDateTime'),
          color: 'error'
        })
      }
    },
    handleClose() {
      // Discard drafts — don't commit anything. Nothing (local state or backend) was
      // ever changed to PICKUP before this point (see closeDialog / OrderTypeSelector.
      // selectOption), so cancelling here has nothing to revert.
      this.draftDay = null
      this.draftTime = null
      this.wasOrderTypeSwitch = false
      this.isStaleTimePrompt = false
      this.staleScheduledTime = null
      this.showChooseAnotherTime = false
      this.selectedSlot = null
      // DEV-10499: belt-and-suspenders -- handleDialogOpen is the normal place this
      // clears (on the false->true @opened transition), but if the dialog was already
      // open when the ASAP-blocked flag got set, @opened never fires and it would
      // otherwise survive to wrongly force the Schedule tab on some later, unrelated
      // open. Clearing here too means it can never outlive this dialog interaction.
      this.SET_PICKUP_DELIVERY_EDIT_DIALOG_ASAP_BLOCKED(false)
      this.SET_PICKUP_DELIVERY_EDIT_DIALOG(false)
    },
    _isNullOrEmpty(val) {
      return isNullOrEmpty(val)
    },
    _isNullOrOne(val) {
      return this._isNullOrEmpty(val) || val.length <= 1
    },
    setDayAndTimeIfOnlyOne() {
      const daysAvailable = this.getStoreAvailableOrderDays;
      const scheduleTakeoutDatetimeManually = get(this.getStore, 'settings.orderSettings.scheduleTakeoutDatetimeManually', null);
      if (scheduleTakeoutDatetimeManually && this.getOrderType !== 'DINE_IN') {
        const hasDefault = daysAvailable.some(day => day.id === 'default');
        if (!hasDefault) {
          daysAvailable.unshift({
            dow: 0,
            id: 'default',
            label: 'Please select a date'
          });
        }
        this.noDaysAvailable = daysAvailable.length <= 1; 
        return; 
      }

      if (daysAvailable && daysAvailable.length > 0) {
        this.scheduledDay = get(daysAvailable, '[0].id');
        this.scheduledTime = get(daysAvailable, '[0].times[0].id');
        this.noDaysAvailable = false;
      } else {
        this.noDaysAvailable = true;
      }
    },

    // Stale-time prompt only: always seed the earliest real day/time, ignoring the
    // store's scheduleTakeoutDatetimeManually setting -- unlike a fresh schedule pick,
    // the user already had a time set, so defaulting to "please select" here would make
    // them start from scratch instead of just replacing the now-invalid slot.
    seedEarliestAvailableDayTime() {
      const realDays = (this.getStoreAvailableOrderDays || []).filter(day => day.id !== 'default');
      if (realDays.length > 0) {
        this.scheduledDay = get(realDays, '[0].id');
        this.scheduledTime = get(realDays, '[0].times[0].id');
        this.noDaysAvailable = false;
      } else {
        this.noDaysAvailable = true;
      }
    },

    dayChanged() {
      this.scheduledTime = ''

      this.$nextTick(() => {
        // Since we disable the select when only 1 option is available we need to set it by default
        if (this.hoursByDay && this.hoursByDay.length == 1)
          this.scheduledTime = this.hoursByDay[0].id
      })
    },

    isDisableSpecialRequest() {
      return get(this.getStore, 'settings.orderSettings.disableSpecialRequestforItem', false)
    },
    toggleButtonClass(index) {
      return index === this.pickupOption ? "selected-btn" : "unselected-btn";
    },
    ...mapMutations([ 'SET_CHECKOUT_INFO', 'SET_PICKUP_DELIVERY_EDIT_DIALOG', 'SET_PICKUP_DELIVERY_EDIT_DIALOG_MESSAGE', 'SET_PICKUP_DELIVERY_EDIT_DIALOG_ASAP_BLOCKED' ]),
    ...mapActions([ 'showSnack', 'setOrderType', 'fetchShoppingCart' ]),
  }
};
</script>

<style scoped>
.dialog-title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1rem;
}

.toggle-group {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}

.selected-btn {
  background-color: var(--v-primary-base)!important;
  color: white !important;
  border-radius: 25px;
  padding: 10px 20px;
  font-weight: bold;
}

.unselected-btn {
  background-color: #f5f5f5 !important;
  color: #333 !important;
  border-radius: 25px;
  padding: 10px 20px;
}

.time-error-message {
  color: #e63d2c;
  font-size: 13px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #fff0ee;
  border-radius: 8px;
  border: 1px solid #f9c9c4;
  line-height: 1.4;
}

.done-button {
  font-size: 14px;
  background-color: var(--v-primary-base)!important;
  color: white !important;
  font-weight: bold;
  width: 100%;
  margin-top: 1rem;
  border-radius: 25px;
}

.header-section {
  display: flex;
  height: 20px;
  justify-content: flex-end;
}

.close-btn {
  margin: 0 !important;
  float: right;
  padding: 0 !important;
}

h2 {
  margin-top: 0;
  margin-bottom: 16px;
}
.toggle-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.toggle-switch {
  display: flex;
  background: #f1f1f1;
  border-radius: 25px;
  padding: 5px;
  width: 60%;
}

.disabled {
   background: grey;
}

.toggle-btn {
  flex: 1;
  border: none;
  padding: 5px 10px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  background: transparent;
  color: #555;
}

.toggle-btn.active {
  background: var(--v-primary-base);
  color: white;
  font-weight: bold;
}


.schedule-container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin-top: 20px;
  padding: 16px;
}

.select-group {
  grid-template-columns: 1fr 1fr;
}

.pickup-instructions {
  margin: 16px 0;
  padding: 12px;
  background-color: #fff8e1;
  border-left: 4px solid #ffd54f;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.dialog-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 24px;
}

.toggle-switch {
  background: #f1f1f1;
  border-radius: 30px;
  padding: 4px;
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
}

.toggle-btn {
  flex: 1;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  color: #666;
}

.toggle-btn.active {
  background: var(--v-primary-base);
  color: white;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.done-button {
  margin-top: 24px;
  width: 100%;
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  background-color: var(--v-primary-base) !important;
  color: white !important;
  transition: all 0.3s ease;
}

.done-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

@media (max-width: 600px) {
  .select-group {
    grid-template-columns: 1fr;
  }

  .toggle-switch {
    width: 100%;
  }

  .toggle-btn {
    padding: 10px 16px;
    font-size: 14px;
  }
}

.stale-time-body {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  margin: 4px 0 24px;
}

.stale-time-body >>> b {
  color: #2c3e50;
}

.suggested-slot-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.suggested-slot-row {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 14px 16px;
  background: white;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.suggested-slot-row.selected {
  border-color: var(--v-primary-base);
  background: #f4f9f7;
}

.suggested-slot-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  margin-right: 12px;
  flex-shrink: 0;
  position: relative;
}

.suggested-slot-row.selected .suggested-slot-radio {
  border-color: var(--v-primary-base);
}

.suggested-slot-row.selected .suggested-slot-radio::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--v-primary-base);
}

.suggested-slot-label {
  font-weight: 700;
  font-size: 15px;
  color: #2c3e50;
}

.suggested-slot-tag {
  margin-left: auto;
  font-size: 13px;
  color: #999;
}

.choose-another-time-link {
  display: block;
  text-align: center;
  color: var(--v-primary-base);
  font-weight: 700;
  text-decoration: underline;
  margin-bottom: 4px;
  cursor: pointer;
}

.go-back-button {
  width: 100%;
  height: 48px;
  margin-top: 10px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  border: 1px solid var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
}
</style>